






























import { Component, Prop, Emit } from 'vue-property-decorator'

import { dateTimeToDisplay, dateToDisplay, dateToNow } from '@/utils/dateTime'
import FoldingCard from '@/components/FoldingCard.vue'
import { mixins } from 'vue-class-component'
import { Case } from '@/modules/Newcase/interfaces/case'
import dollarFilter from '@/utils/dollarFilter'
import { casePriority } from '@/modules/Newcase/helpers/case'
import AccountAssets from '@/modules/Newcase/components/AccountAssets.vue'
import AccountCertificates from '@/modules/Newcase/components/AccountCertificates.vue'
import CaseAttachmentsCard from '../components/CaseAttachmentCard.vue'
import AccountInfo from '@/modules/Newcase/components/AccountInfo.vue'
import CasePolicyInfo from '../components/CasePolicyInfo.vue'
import CasePolicyDocusign from '../components/CasePolicyDocusign.vue'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'

@Component({
  components: {
    FoldingCard,
    AccountAssets,
    AccountCertificates,
    CaseAttachmentsCard,
    AccountInfo,
    CasePolicyInfo,
    CasePolicyDocusign,
    CaseFoldingCard
  }
})
export default class CaseCompletedDrawer extends mixins() {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  folding = false

  dollarFilter = dollarFilter
  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  dateToNow = dateToNow
  casePriority = casePriority

  get attachmentList () {
    if (!this.caseInfo) {
      return []
    }
    return this.caseInfo.account.attachments || []
  }

  get policy () {
    return this.caseInfo.policies[this.caseInfo.policies.length - 1]
  }

  closingHandler () {
    this.folding = true
    setTimeout(() => {
      this.onClose()
    }, 500)
  }

  @Emit('close')
  onClose () {
    // do nothing
  }
}
